'use es6';

import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ContactsIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import StepInterface from './StepInterface';
import { CHOOSE_PROVIDER_STEP, CONNECT_INBOX_STEP, CUSTOM_EMAIL_DETECT_STEP } from '../../constants/InboxConnectStepKeys';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const clientConfig = {
  gmail: {
    company: 'Google',
    name: 'Gmail'
  },
  outlook: {
    company: 'Microsoft',
    name: 'Outlook'
  },
  outlook365: {
    company: 'Microsoft',
    name: 'Outlook 365'
  },
  outlook365GccHigh: {
    company: 'Microsoft',
    name: 'Outlook 365 GCC High'
  },
  exchange: {
    company: 'Microsoft',
    name: 'Exchange'
  },
  imap: {
    company: 'Imap',
    name: 'Imap'
  }
};
export default class CustomEmailDetectStep extends Component {
  constructor(...args) {
    super(...args);
    this.onClickConnectToProvider = () => {
      this.props.trackingClient.trackStepAction(CUSTOM_EMAIL_DETECT_STEP, 'clicked connect client');
      const {
        setShownStep
      } = this.props;
      setShownStep(CONNECT_INBOX_STEP);
    };
    this.onClickChooseProviderLink = () => {
      this.props.trackingClient.trackStepAction(CUSTOM_EMAIL_DETECT_STEP, 'clicked choose provider link');
      this.props.setShownStep(CHOOSE_PROVIDER_STEP);
    };
    this.renderChooseDifferentProviderLink = () => {
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsx(Link, {
          onClick: this.onClickChooseProviderLink,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'InboxConnectUtils.wizard.customEmailDetect.chooseProviderMyself'
          })
        })
      });
    };
    this.renderConnectButton = () => {
      const {
        selectedClient
      } = this.props;
      const {
        name = selectedClient
      } = clientConfig[selectedClient];
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: this.onClickConnectToProvider,
          "data-test-id": "connect-to-provider-button",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: 'InboxConnectUtils.wizard.customEmailDetect.connectToProvider',
            options: {
              provider: name
            }
          })
        })
      });
    };
    this.renderRecommendation = () => {
      const {
        selectedClient
      } = this.props;
      const {
        company = selectedClient,
        name = selectedClient
      } = clientConfig[selectedClient];
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsx(Text, {
          as: "strong",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: 'InboxConnectUtils.wizard.customEmailDetect.recommendForProvider',
            options: {
              company,
              providerName: name
            }
          })
        })
      });
    };
    this.renderEmail = () => {
      const {
        emailAddress
      } = this.props;
      return /*#__PURE__*/_jsx(Flex, {
        inlineSize: "100%",
        justifyContent: "center",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "center",
          paddingInline: "600",
          paddingBlock: "100",
          inlineSize: "fit-content",
          borderWidth: "200",
          borderStyle: "solid",
          borderColor: "border-core-subtle",
          borderRadius: "full",
          children: [/*#__PURE__*/_jsx(ContactsIcon, {
            size: "300",
            color: "icon-core-default"
          }), /*#__PURE__*/_jsx(Text, {
            as: "span",
            display: "inline",
            paddingInlineStart: "200",
            fontWeight: "600",
            truncate: true,
            "data-test": "email-input",
            children: emailAddress
          })]
        })
      });
    };
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(CUSTOM_EMAIL_DETECT_STEP);
  }
  render() {
    return /*#__PURE__*/_jsx(Flex, {
      direction: "row",
      justifyContent: "center",
      "data-selenium": "custom-email-detect-step",
      children: /*#__PURE__*/_jsxs(View, {
        inlineSize: "460px",
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "heading-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'InboxConnectUtils.wizard.customEmailDetect.title'
          })
        }), this.renderEmail(), this.renderRecommendation(), this.renderConnectButton(), this.renderChooseDifferentProviderLink()]
      })
    });
  }
}
CustomEmailDetectStep.propTypes = StepInterface;